export default "__VITE_PUBLIC_ASSET__b6f706ab__"